import React from "react";

const FlightTicketGstDetails = (props) => {
    return(
        <div className="gst-details-table-container">
            <table className="gst-details-table" style={{ width: "100%" }}>
                <thead>
                    <tr>
                        <th>GST Number</th>
                        <th>Name</th>
                        <th>Address</th>
                        <th>Email</th>
                        <th>Mobile</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.gstInfo?.gstNo}</td>
                        <td>{props.gstInfo?.gstCompanyName}</td>
                        <td>{props.gstInfo?.gstCompanyAddress}</td>
                        <td>{props.gstInfo?.gstEmail}</td>
                        <td>{props.gstInfo?.gstMobile}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default FlightTicketGstDetails;
